export const SELECT_PRODUCT_BUMNAN_READY = 'SELECT_PRODUCT_BUMNAN_READY'

export const selectProductBumnanReady = (productCode) => ({
  type: SELECT_PRODUCT_BUMNAN_READY,
  payload: productCode,
})

export const SELECT_BASIC_PLAN = 'SELECT_BASIC_PLAN'
export const selectBasicPlan = (product) => ({
  type: SELECT_BASIC_PLAN,
  payload: product,
})

export const SELECT_PRODUCT_BUMNAN_SMART = 'SELECT_PRODUCT_BUMNAN_SMART'

export const selectProductBumnanSmart = (productCode) => ({
  type: SELECT_PRODUCT_BUMNAN_SMART,
  payload: productCode,
})
